// Language switch. `compact` (ES | EN) lives in the shell header; `pills`
// (Español | English) is the big picker on the attract screen.

import { useLang } from "../i18n/LangContext";
import { LANG_LABEL, LANGS } from "../i18n/strings";

export function LanguageToggle({
  variant = "compact",
}: {
  variant?: "compact" | "pills";
}) {
  const { lang, setLang } = useLang();

  if (variant === "pills") {
    return (
      <div className="lang-pills">
        {LANGS.map((code) => (
          <button
            className={
              code === lang ? "lang-pill lang-pill--active" : "lang-pill"
            }
            key={code}
            onClick={() => setLang(code)}
            type="button"
          >
            {LANG_LABEL[code]}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="lang-toggle">
      {LANGS.map((code) => (
        <button
          className={
            code === lang
              ? "lang-toggle__opt lang-toggle__opt--active"
              : "lang-toggle__opt"
          }
          key={code}
          onClick={() => setLang(code)}
          type="button"
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
